<template>
  <div class="header-content">
    <img class="header-img" src="@/assets/header.jpg">
    <img class="header-phone" src="@/assets/header-phone.jpg">
    <!-- <img class="logo" src="@/assets/logo.png" alt="logo"> -->
    <div class="title">{{ config.title }}</div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-content{
  position: relative;
  .title{
    position: absolute;
    bottom: 40px;
    width: 100%;
    text-align: center;
    color: #fff;
    -webkit-text-stroke: 1px #000; 
    font-weight: 900;
    font-size: 38px;
  }
  .header-img{
    width: 100%;
    height: 700px;
  }
  .logo{
    position: absolute;
    top: 20px;
    right: 310px;
    width: 200px;
    height: 200px;
  }
  .header-phone{
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .header-content{
    .header-img{
      display: none;
    }
    .header-phone{
      display: block;
      width: 100%;
      height: 558px;
    }
    .title{
      position: absolute;
      bottom: 40px;
      font-size: 38px;
    }
    .logo{
      top: 150px;
      right: 270px;
    }
  }
}
</style>